<template>
    <div>
        <table class="table">
            <tbody>
            <app-list-item v-for="item in list" :item="item"></app-list-item>
            </tbody>
        </table>
    </div>
</template>

<script>
  import ListItem from './ListItem'
  import data from '../../data/products'

  export default {
    data () {
      return {
        list: data
      }
    },
    components: {
      appListItem: ListItem
    }
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';
</style>

